import request from '@/utils/request'


// 查询用户步数列表
export function listStep(query) {
  return request({
    url: '/joe/user-step/list',
    method: 'get',
    params: query
  })
}

// 查询用户步数分页
export function pageStep(query) {
  return request({
    url: '/joe/user-step/page',
    method: 'get',
    params: query
  })
}

// 查询用户步数详细
export function getStep(data) {
  return request({
    url: '/joe/user-step/detail',
    method: 'get',
    params: data
  })
}

// 新增用户步数
export function addStep(data) {
  return request({
    url: '/joe/user-step/add',
    method: 'post',
    data: data
  })
}

// 修改用户步数
export function updateStep(data) {
  return request({
    url: '/joe/user-step/edit',
    method: 'post',
    data: data
  })
}

// 删除用户步数
export function delStep(data) {
  return request({
    url: '/joe/user-step/delete',
    method: 'post',
    data: data
  })
}
